// extracted by mini-css-extract-plugin
export default {"container":"S04_container__jmnSl","limiter":"S04_limiter__Ey6Ft"};